module.exports = __webpack_public_path__ + "5d41629e9dc8cd325b801e98cded1fce.png";